import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "../../Hooks";
import { useStyles } from "./FmCarbonFootprintTable.style";
import { useDispatch } from "react-redux";
import { AgriSolutionState } from "../../Redux";

export const FmCarbonTableHeaderRow = () => {
    const { headerText, firstColumnText, headerTextWidthPadding } = useStyles();
    const theme = useTheme();
    const dispatch = useDispatch();

    return (
        <Stack direction='row' justifyContent='space-between' sx={{ borderBottom: "1px solid #7C7C7C50" }}>
            <Box className={firstColumnText} sx={{ width: "20%", padding: "32px 0" }}>
                <span>Environmental parameters</span>
            </Box>

            <Box
                className={headerTextWidthPadding}
                sx={{
                    paddingTop: "32px",
                    paddingBottom: "32px",
                    backgroundColor: "#e4f5ec",
                    borderRadius: "8px 8px 0 0",
                    color: "#248B5B",
                }}
            >
                <span>Multicote™ Technology</span>
            </Box>

            <Box
                className={headerTextWidthPadding}
                sx={{
                    paddingTop: "32px",
                    paddingBottom: "32px",
                    backgroundColor: "#F3F3F3",
                    borderRadius: "8px 8px 0 0",
                    color: "#000",
                }}
            >
                <span>Traditional application</span>
            </Box>

            <Stack direction='column' sx={{ width: "30%", paddingTop: "32px" }} alignItems={"center"}>
                <Box className={headerText}>Multicote™ Technology rating performance</Box>

                <Stack direction='row' gap='5px' sx={{ cursor: "pointer" }} onClick={() => dispatch(AgriSolutionState.Actions.toggleIndexDialog(true))}>
                    <img src={theme.images.helpCircle} alt='index' />

                    <Typography sx={{ fontSize: 16, textDecoration: "solid underline" }}>Index</Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
